export default __webpack_public_path__ + "static/media/eyeson-login.9496e1b0.png";